export const RELOAD_AMOUNTS = [10, 20, 30, 40, 50];
